export function AnalyticsStatus({message, retry, error = false}: {
    message: string,
    retry?: () => void,
    error?: boolean
}) {
    return <div role={error ? "alert" : "status"}
        className="w-full p-[20px] bg-white rounded-[20px] text-center">
        <p>{message}</p>
        {retry && <button type="button" onClick={retry}
            className="mt-[10px] min-h-[44px] px-[15px] text-[#1178D6] underline">
            Спробувати ще раз
        </button>}
    </div>;
}
